import { apiRequest } from "@/lib/api/client";
import type { LoginResponse } from "@/lib/types";

export const authApi = {
  login(username: string, password: string) {
    return apiRequest<LoginResponse>("/assistant/auth/login", {
      method: "POST",
      body: { username, password },
    });
  },
};
